import React, { Fragment } from "react";
import { Seo, Breadcrumb, ScrollTopBtn,Button } from "../components";
import { HeaderThree, BlogOne, FooterTwo } from "../containers";
const Blog = () => (
  <Fragment>
    <Seo
      title="Tech Ayukta Blogs — Insights on Technology, ERP, and Digital Transformation"
      description="Explore the latest blogs from Tech Ayukta covering ERP solutions, custom software, web & mobile app development, IT consulting, and digital transformation strategies for modern businesses."
      keywords="Tech Ayukta Blog, ERP Solutions, IT Consulting, Web Development, Mobile App Development, Custom Software, Digital Transformation, Business Automation, Technology Insights"
      canonical="https://www.techayukta.com/blog"
    />
    <HeaderThree />
    <Breadcrumb
      pageName="Blog List"
      bgImage="/images/breadcumb/breadcumb-bg.jpg"
    />
   <div className="container mt-3 d-none d-md-block">
    <Button path="/blog-grid">Blog Grid View<i className="far fa-arrow-right"/></Button>
   </div>
    <BlogOne className="space-top space-extra-bottom pt-5 pt-md-2" />
    <FooterTwo />
    <ScrollTopBtn />
  </Fragment>
);

export default Blog;
